import { IVasInfo } from '@r1-frontend/api-domru/api-profile/v1/vas/dto/ResponseDto';

import { IAction } from '~/src/store';
import {
    VAS_ANTIVIRUS_LOAD_ERROR,
    VAS_ANTIVIRUS_LOADED,
    VAS_ANTIVIRUS_LOADING,
    VAS_DISABLING_STATUS_CHANGE,
    VAS_GAMERSBASE_URL,
    VAS_LOAD_ERROR,
    VAS_LOADED,
    VAS_LOADING,
    VAS_SET_VAS_ERROR,
    VAS_SUBSCRIPTIONS_LOAD_ERROR,
    VAS_SUBSCRIPTIONS_LOADED,
    VAS_SUBSCRIPTIONS_LOADING,
} from '~/src/store/actionTypes/vas';
import { EVasDisablingStatus } from '~/src/store/reducers/vas';

export function loadingVas(): IAction<typeof VAS_LOADING> {
    return {
        type: VAS_LOADING,
        payload: null,
    };
}

export function vasLoaded(vasInfo: IVasInfo[]): IAction<typeof VAS_LOADED, IVasInfo[]> {
    return {
        type: VAS_LOADED,
        payload: vasInfo,
    };
}

export function vasLoadError(): IAction<typeof VAS_LOAD_ERROR> {
    return {
        type: VAS_LOAD_ERROR,
        payload: null,
    };
}

export function vasAntivirusLoading(): IAction<typeof VAS_ANTIVIRUS_LOADING> {
    return {
        type: VAS_ANTIVIRUS_LOADING,
        payload: null,
    };
}

export function vasAntivirusLoaded(vasInfo: IVasInfo[]): IAction<typeof VAS_ANTIVIRUS_LOADED, IVasInfo[]> {
    return {
        type: VAS_ANTIVIRUS_LOADED,
        payload: vasInfo,
    };
}

export function vasAntivirusError(): IAction<typeof VAS_ANTIVIRUS_LOAD_ERROR> {
    return {
        type: VAS_ANTIVIRUS_LOAD_ERROR,
        payload: null,
    };
}

export function vasSubscriptionsLoading(): IAction<typeof VAS_SUBSCRIPTIONS_LOADING> {
    return {
        type: VAS_SUBSCRIPTIONS_LOADING,
        payload: null,
    };
}

export function vasSubscriptionsLoaded(vasInfo: IVasInfo[]): IAction<typeof VAS_SUBSCRIPTIONS_LOADED, IVasInfo[]> {
    return {
        type: VAS_SUBSCRIPTIONS_LOADED,
        payload: vasInfo,
    };
}

export function vasSubscriptionsError(): IAction<typeof VAS_SUBSCRIPTIONS_LOAD_ERROR> {
    return {
        type: VAS_SUBSCRIPTIONS_LOAD_ERROR,
        payload: null,
    };
}

export function vasDisablingStatusChange(status: EVasDisablingStatus): IAction<typeof VAS_DISABLING_STATUS_CHANGE, EVasDisablingStatus> {
    return {
        type: VAS_DISABLING_STATUS_CHANGE,
        payload: status,
    };
}

export function setVasError(error: string): IAction<typeof VAS_SET_VAS_ERROR, string> {
    return {
        type: VAS_SET_VAS_ERROR,
        payload: error,
    };
}

export function setGamersBaseUrl(url: string): IAction<typeof VAS_GAMERSBASE_URL, string> {
    return {
        type: VAS_GAMERSBASE_URL,
        payload: url,
    };
}
